import { LEVEL_TONE } from './announcementLevels'
import { useActiveAnnouncements } from './useActiveAnnouncements'

/**
 * Плашка с объявлением под шапкой. Работать не мешает: одна-две строки и
 * крестик. Закрытая плашка не возвращается ни на других страницах, ни после
 * перезагрузки — это решает сервер. Пока объявлений нет — ничего не рисует.
 */
export function AnnouncementBanner() {
  const { banners, dismiss, dismissing } = useActiveAnnouncements()
  if (banners.length === 0) return null

  return (
    <div className="shrink-0">
      {banners.map((a) => (
        <div
          key={a.id}
          role="status"
          className={`flex items-start gap-3 border-b px-3 py-2 text-sm lg:px-6 ${LEVEL_TONE[a.level]}`}
        >
          <div className="min-w-0 flex-1 break-words">
            <span className="font-medium">{a.title}</span>
            {a.body && <span className="ml-2 whitespace-pre-line">{a.body}</span>}
          </div>
          <button
            type="button"
            onClick={() => dismiss(a.id)}
            disabled={dismissing}
            aria-label="Скрыть объявление"
            className="-mr-1 shrink-0 rounded-lg p-1 opacity-70 transition-opacity hover:opacity-100 disabled:opacity-40"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              aria-hidden
            >
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>
      ))}
    </div>
  )
}
